// Misma regla que backend/core/email_check.py. Devuelve el motivo o null si es válido/vacío.
const EMAIL_FORMAT_RE = /^[A-Za-z0-9._%+'-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

export const emailProblem = (raw, lang = 'es') => {
  const s = (raw || '').trim();
  if (!s) return null;
  const es = lang === 'es';
  if (s.includes(' ')) return es ? 'El email no puede contener espacios' : 'Email cannot contain spaces';
  const local = s.split('@')[0];
  if (!EMAIL_FORMAT_RE.test(s) || s.includes('..') || local.startsWith('.') || local.endsWith('.')) {
    return es ? 'Email no válido: revisa el formato (ej. nombre@dominio.com)' : 'Invalid email format (e.g. name@domain.com)';
  }
  return null;
};
